import { render, staticRenderFns } from "./vs_csm_trn_workcalendar.vue?vue&type=template&id=8a479dfe&scoped=true"
import script from "./vs_csm_trn_workcalendar.vue?vue&type=script&lang=js"
export * from "./vs_csm_trn_workcalendar.vue?vue&type=script&lang=js"
import style0 from "./vs_csm_trn_workcalendar.vue?vue&type=style&index=0&id=8a479dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a479dfe",
  null
  
)

export default component.exports